import { render, staticRenderFns } from "./checkout-cancelled.vue?vue&type=template&id=3228443a&scoped=true&"
import script from "./checkout-cancelled.vue?vue&type=script&lang=js&"
export * from "./checkout-cancelled.vue?vue&type=script&lang=js&"
import style0 from "./checkout-cancelled.vue?vue&type=style&index=0&id=3228443a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3228443a",
  null
  
)

export default component.exports